import { useState } from "react";
import { Star } from "lucide-react";
import { api, apiErr } from "../lib/api";
import { useT } from "../context/LanguageContext";
import { toast } from "sonner";

export function StarRating({ value, onChange, readOnly = false, size = "w-6 h-6" }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          data-testid={`star-${n}`}
          onMouseEnter={() => !readOnly && setHover(n)}
          onMouseLeave={() => !readOnly && setHover(0)}
          onClick={() => !readOnly && onChange(n)}
          className={readOnly ? "cursor-default" : "cursor-pointer"}
        >
          <Star className={`${size} transition-colors ${(hover || value) >= n ? "fill-alert text-alert" : "text-line"}`} />
        </button>
      ))}
    </div>
  );
}

export function FeedbackPrompt({ appt, onDone }) {
  const [rating, setRating] = useState(0);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const { t } = useT();

  const submit = async () => {
    if (!rating) return toast.error(t("Please pick a star rating first."));
    setBusy(true);
    try {
      await api.post(`/appointments/${appt.id}/feedback`, { rating, note });
      toast.success(t("Thanks for your feedback!"));
      onDone?.();
    } catch (e) { toast.error(apiErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="feedback-prompt" className="w-full mt-3 border-t border-line pt-3">
      <p className="text-sm font-semibold text-ink">{t("How was your consultation?")}</p>
      <div className="mt-2 flex flex-wrap items-center gap-3">
        <StarRating value={rating} onChange={setRating} />
        <input
          data-testid="feedback-note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={t("Add a note (optional)")}
          className="flex-1 min-w-[180px] border border-line bg-white rounded-md px-3 py-2 text-sm outline-none focus:border-clinical"
        />
        <button onClick={submit} disabled={busy} data-testid="feedback-submit-btn" className="bg-clinical text-white text-sm font-semibold rounded-md px-4 py-2 disabled:opacity-60">
          {busy ? t("Sending…") : t("Submit")}
        </button>
      </div>
    </div>
  );
}
